ui-cms-bank-search {
  display: block;
  position: relative;

  .sd-hidden-links {
    z-index: 1;
  }

  .skip-location:focus {
    outline: 0;
  }
}
